import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {fetchGlobalProducts, updateProducts} from "../../store/product-slice";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";

const ProductUpdate = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();

    const {
        globalProducts,
        selectedData: selectedGlobalProducts,
        fetchGlobalProductsStatus,
        updateStatus,
        error,
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator("..");
        }
    }, [updateStatus, navigator]);

    useEffect(() => {
        dispatch(fetchGlobalProducts(userRole));
    }, [dispatch, userRole]);

    useEffect(() => {
        if (globalProducts.length > 0 && selectedGlobalProducts.length > 0) {
            setSelectedProducts(selectedGlobalProducts);
        }
    }, [globalProducts, selectedGlobalProducts]);

    useEffect(() => {
        setSelectAll(selectedProducts.length === globalProducts.length);
    }, [selectedProducts, globalProducts]);

    const handleCheckboxChange = (productId) => {
        setSelectedProducts(prevState =>
            prevState.includes(productId)
                ? prevState.filter(id => id !== productId)
                : [...prevState, productId]
        );
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedProducts([]);
        } else {
            setSelectedProducts(globalProducts.map(product => product.id));
        }
        setSelectAll(!selectAll);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(updateProducts({...userRole, products: selectedProducts}));
    };

    return (
        <>
            <SubHeader title="Update Products">
                <Button to="../" className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchGlobalProductsStatus === "loading" && <p>Loading...</p>}
                {fetchGlobalProductsStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {updateStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchGlobalProductsStatus === "success" && (
                    <form onSubmit={handleSubmit}>
                        <div className="form-check py-1">
                            <input
                                type="checkbox"
                                id="selectAll"
                                className="form-check-input"
                                checked={selectAll}
                                onChange={handleSelectAllChange}
                            />
                            <label htmlFor="selectAll" className="form-check-label">
                                Select / Unselect All
                            </label>
                        </div>
                        <div className="row">
                            {globalProducts.map(product => (
                                <div key={product.id} className="col-md-4 col-lg-3">
                                    <div className="form-check py-1">
                                        <input
                                            type="checkbox"
                                            value={product.id}
                                            id={product.id}
                                            checked={selectedProducts.includes(product.id)}
                                            onChange={() => handleCheckboxChange(product.id)}
                                            className="form-check-input"
                                        />
                                        <label htmlFor={product.id} className="form-check-label">
                                            {product.name}
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-primary mt-3">
                            Submit
                        </button>
                    </form>
                )}
            </div>
        </>
    );
};

export default ProductUpdate;
